export class HttpException extends Error {
  public name: string;
  public code?: number;
  public message: string;
  public errors: Array<string> | undefined;

  constructor(message: string, code?: number, errors?: string[]) {
    super(message);
    this.name = "HttpException";
    this.code = code;
    this.message = message;
    this.errors = errors;
  }
}
